import React, { useState } from 'react';
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  TextField,
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import onKeyClick from '../../../utils/eventListeners';

const SamplesRelabelDialog = ({
  classes = {},
  samplesToRelabel = [],
  loading,
  onRelabelSamples = () => {},
  handleClose = () => {},
}) => {
  const [newLabel, setNewLabel] = useState('');

  const relabelClose = () => {
    onRelabelSamples(newLabel);
    setNewLabel('');
    handleClose();
  };

  const handleKeyboardShortcuts = (e) => {
    onKeyClick(e, 13, relabelClose);
  };

  return (
    <Dialog
      onKeyUp={handleKeyboardShortcuts}
      maxWidth="xs"
      open={!!samplesToRelabel.length}
      onClose={() => {
        setNewLabel('');
        handleClose();
      }}
    >
      <DialogContent style={{ padding: 20 }}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} container justifyContent="center" spacing={2}>
            <TextField
              autoFocus
              label="New Label"
              onChange={(e) => setNewLabel(e.target.value)}
              value={newLabel}
            />
          </Grid>
          <Grid item xs={12} container justifyContent="center" spacing={2}>
            <Grid item>
              <Button
                size="small"
                className={classes.redButton}
                variant="contained"
                disabled={loading}
                disableElevation
                onClick={() => {
                  setNewLabel('');
                  handleClose();
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                className={classes.blueButton}
                variant="contained"
                disabled={!newLabel}
                endIcon={<SaveIcon />}
                disableElevation
                onClick={relabelClose}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default SamplesRelabelDialog;
